import { animate, query, stagger, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { MeliCategoryFinderComponent } from '../meli-category-finder/meli-category-finder.component';
import { options, VariationServices } from '../meli-item-variation/meli-item-variation.component';
import { MeliCategoryPredictorComponent } from './meli-category-predictor/meli-category-predictor.component';
import { ThemeService } from 'src/app/services/theme.service';
import { FormServices } from 'src/app/services/form.services';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UserConfigServices } from 'src/app/services/user-config.services';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';

@Component({
    selector: 'meli-edit-form',
    templateUrl: './meli-edit-form.component.html',
    styleUrls: ['./meli-edit-form.component.scss'],
    animations: [trigger('indicatorRotate', [
            state('collapsed', style({ transform: 'rotate(0deg)' })),
            state('expanded', style({ transform: 'rotate(180deg)' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
        ]),
        trigger('listAnimation', [
            transition('* => *', [
                query(':leave', [
                    stagger(0, [
                        animate('0.1s', style({ opacity: 0 }))
                    ])
                ], { optional: true }),
                query(':enter', [
                    style({ opacity: 0 }),
                    stagger(100, [
                        animate('0.3s', style({ opacity: 1 }))
                    ])
                ], { optional: true })
            ])
        ])
    ],
    standalone: false
})
export class MeliEditFormComponent implements OnInit {
  showHiddenGarantia: boolean = false;
  showHiddenAtributo: boolean = false;
  showMulti: boolean = false;


  constructor(private formBuilder:UntypedFormBuilder, private http:HTTPService, private spinner:NgxSpinnerService, private cd:ChangeDetectorRef,
    private snackBar:SnackbarService,public ThemeService:ThemeService, private dialogService:DialogService, private varServices:VariationServices,
  private formServices:FormServices, private message:NzMessageService,
  private userConfigServices:UserConfigServices, private us:UserAuthenticationServices) {

   }

  visible = 1;
  formGroup:UntypedFormGroup;
  formMore:UntypedFormGroup;
  formMid:UntypedFormGroup;
  formStatus:UntypedFormGroup;
  imageCtrl:UntypedFormControl = new UntypedFormControl();
  @Input('data') data:any;
  @Input('row') row:any;
  coldef:columnsDef[] = [];
  dataValue:Map<String,Object> = new Map<String,Object>();
  allImages:string[] = [];
  images: string[] = [];
  attribs: object[] = [];
  garantias:object[] = [];
  selectedAtrib:Object[] = [];
  selectedGarantia:Object[] = [];
  selectable = true;
  removable = true;
  formCompl:UntypedFormGroup;
  selectedPrediction = null;
  prediction:Object[] = [];
  attribValidator:AbstractControl[] = [];
  attribComponente = MeliCategoryFinderComponent
  @Output('saving') saving:EventEmitter<{changing:boolean, keepOpen:boolean}> = new EventEmitter<{changing:boolean, keepOpen:boolean}>();
  evento:string;
  variacoes:object[] = [];
  varAttribs:object[] = [];
  varimage:String[] = [];
  tipoVariacao = null;
  selectedDataVar = {};
  editVarFace = false;
  disableAddVar = false;
  dataObserve =null;
  disablePredict =false;
  byCatalogo = false;
  // oldarrays
  oldAttribVar: object[];
  oldImageVar: String[];
  oldVariacoes: object[];
  oldGarantias: Object[];
  oldAtrib: Object[];
  oldImagens: string[];
  dataMultiTable: Object[]=[];
  dataMultiTableConfig:{columnName:string,columnDesc:string, colspan:number, format:string,dateFromFormat?:string, dateFormat?:string}[] = [];
  expanded=false;
  currentStep = 0;

  // ===== Preferência do usuário: quantidade de colunas do formulário =====
  private static readonly PREFERENCE_ID = 'meli_edit_form';
  formColumns = 0; // 0 = automático (grid responsivo)

  get gridTemplateColumns(): string | null {
    return this.formColumns > 0 ? `repeat(${this.formColumns}, minmax(0, 1fr))` : null;
  }

  loadUserPreference(){
    this.userConfigServices.loadUserPreference(this.us.user.iduser, MeliEditFormComponent.PREFERENCE_ID).subscribe(data=>{
        let pref:Object[] = data['Mktpuserpref'];
        if ( ObjectUtil.isNotEmpty(pref) && pref.length > 0 ){
          let prefObject:Object = JSON.parse(pref[0]['PREFERENCE']);
          if ( prefObject['formColumns'] != null ){
            this.formColumns = Number(prefObject['formColumns']);
            this.cd.markForCheck();
          }
        }
    });
  }

  onColumnsChange(value:number){
    this.formColumns = value;
    this.userConfigServices.saveUserResource(MeliEditFormComponent.PREFERENCE_ID, this.us.user.iduser, { formColumns: value });
  }

  // cache: o getter roda a cada ciclo de change detection; devolver um array
  // novo a cada chamada faz o *ngFor recriar os nz-steps continuamente e trava a tela
  private cachedSteps: {id:string, title:string}[] = [];
  private cachedStepsSignature = '';

  get visibleSteps(): {id:string, title:string}[] {
    let steps: {id:string, title:string}[] = [];
    steps.push({id:'info', title:'meli.form.step.info'});
    if ( this.showMulti && this.evento=='inserindo'){
      steps.push({id:'multi', title:'meli.form.step.multi'});
    }
    if ( !this.byCatalogo ){
      steps.push({id:'more', title:'meli.form.step.more'});
    }
    steps.push({id:'mid', title:'meli.form.step.mid'});
    if ( !this.byCatalogo ){
      steps.push({id:'attrib', title:'meli.form.step.attrib'});
      if ( !this.canAddVariation() ){
        steps.push({id:'var', title:'meli.form.step.var'});
      }
    }
    steps.push({id:'status', title:'meli.form.step.status'});

    let signature = steps.map(s=>s.id).join('|');
    if ( signature !== this.cachedStepsSignature ){
      this.cachedStepsSignature = signature;
      this.cachedSteps = steps;
    }
    return this.cachedSteps;
  }

  trackStep(index:number, step:{id:string, title:string}){
    return step.id;
  }

  get currentStepId(): string {
    let steps = this.visibleSteps;
    let index = Math.min(this.currentStep, steps.length-1);
    return steps[index].id;
  }

  nextStep(){
    if ( this.currentStep < this.visibleSteps.length-1 ){
      this.currentStep++;
    }
  }

  previousStep(){
    if ( this.currentStep > 0 ){
      this.currentStep--;
    }
  }



  getOptions(value:string){

      let idata:options[] = [];
      this.coldef.forEach( l => {
          if ( l.COLUMNNAME.toUpperCase() == value.toUpperCase() ){
              if ( l.VALIDATIONERROR != null ){
                var ob:Object = JSON.parse(l.VALIDATIONERROR);
                if ( ob['type']=='select'){
                  idata = ob['options'];
                }
              }
          }
      })

      this.dataValue.set(value,idata);
  }



  ngOnInit(): void {

      this.loadUserPreference();

      this.formCompl = this.formBuilder.group({});
      this.formMid = this.formBuilder.group({});
      this.formStatus = this.formBuilder.group({});
      this.formGroup = this.data.formGroup;
      this.evento = this.data.evento;
      if ( this.data.parentRow != null ){
        this.formGroup.addControl("CODEPRODUCT",new UntypedFormControl(this.data.parentRow.linha["CODEPRODUCT"]));
        this.formGroup.addControl("CODECONTRACT",new UntypedFormControl(this.data.parentRow.linha["CODECONTRACT"]));
      }else{        
        this.formGroup.addControl("CODEPRODUCT",new UntypedFormControl(this.data.row["CODEPRODUCT"]));
        this.formGroup.addControl("CODECONTRACT",new UntypedFormControl(this.data.row["CODECONTRACT"]));
      }
      

      if( this.evento=="inserindo"){
        this.formGroup.addControl('CODEMELI',new UntypedFormControl(null));
        this.formGroup.addControl("CODECOMPANY",new UntypedFormControl(null,[Validators.required]));
      }else{
        this.formGroup.get('CODEPRODUCT').disable();
        this.formGroup.get('CODECONTRACT').disable();
        this.formGroup.addControl("CODECOMPANY",new UntypedFormControl(this.data.row["CODECOMPANY"],[Validators.required]));
        this.formGroup.get('CODECOMPANY').disable();
        this.formGroup.addControl("CODEMELI",new UntypedFormControl(this.data.row["CODEMELI"],));
      }
      
      this.formGroup.addControl('catalog_product_id',new UntypedFormControl(null));
      this.formGroup.get('catalog_product_id').disable();
      this.formGroup.addControl('title',new UntypedFormControl(null, [Validators.required,Validators.maxLength(60)]));
      this.formGroup.addControl('FAMILY_NAME',new UntypedFormControl(null, [Validators.maxLength(120)]));
      this.formGroup.addControl('USER_PRODUCT_ID',new UntypedFormControl(null));
      this.formGroup.addControl('category_id',new UntypedFormControl(null,[Validators.required]));
      this.formGroup.addControl('buying_mode',new UntypedFormControl(null,[Validators.required]));
      this.formGroup.addControl('currency_id',new UntypedFormControl(null,[Validators.required]));
      this.formGroup.addControl('listing_type_id',new UntypedFormControl(null,[Validators.required]));
      this.formGroup.addControl('shipping',new UntypedFormControl(null,[Validators.required]));
      this.formGroup.addControl('item_condition',new UntypedFormControl(null,[Validators.required]));
      this.formGroup.addControl('permlink',new UntypedFormControl({value:null,disabled:false}));
      this.formGroup.addControl('video_id',new UntypedFormControl(null));
      this.formGroup.addControl('official_store_id',new UntypedFormControl(null));
      this.formGroup.addControl('mlb_anuncio',new UntypedFormControl({value:null,disabled:false}));
      this.formGroup.addControl('active',new UntypedFormControl(true));
      this.formGroup.addControl('warranty',new UntypedFormControl(null));
      this.formGroup.addControl('envfull',new UntypedFormControl(null));
      this.formMid.addControl('price',new UntypedFormControl(null));
      this.formMid.addControl('available_quantity',new UntypedFormControl(null,[Validators.max(99999), Validators.min(0)]));
      this.formMid.addControl('percentstk',new UntypedFormControl(null));
      this.formMid.addControl('multiplicador',new UntypedFormControl(null));
      this.formMid.addControl('percacres',new UntypedFormControl(null));
      this.formMid.addControl('percdesconto',new UntypedFormControl(null));
      this.formMid.addControl('datavalpromo',new UntypedFormControl(null));
      this.formMid.addControl('tabpreco',new UntypedFormControl(null));
      this.formMid.addControl('codtab',new UntypedFormControl(null));
      this.formMid.addControl('codlocal',new UntypedFormControl(null));
      this.formMid.addControl('porlocal',new UntypedFormControl(null));
      
      
    
      this.formStatus.addControl("envdescr",new UntypedFormControl({value:null,disabled:true}));
      this.formStatus.addControl("envpicture",new UntypedFormControl({value:null,disabled:true}));
      this.formStatus.addControl("envatrib",new UntypedFormControl({value:null,disabled:true}));
      this.formStatus.addControl("envavar",new UntypedFormControl({value:null,disabled:true})); 
      this.formStatus.addControl("message",new UntypedFormControl({value:null,disabled:true})); 
      this.formStatus.addControl("status",new UntypedFormControl({value:null,disabled:true})); 

    this.formMore = this.formBuilder.group({
        description:[null,Validators.required],
    });


    
    this.spinner.show("meliitemcontainer");
      
    this.formGroup.get('catalog_product_id').valueChanges.subscribe(data=>{
        if ( data ){
          this.byCatalogo = true;
          // No fluxo por catálogo o passo "+ Informações" fica oculto:
          // a descrição não pode continuar obrigatória, senão o salvar trava
          // validando um campo que o usuário não consegue ver/editar.
          this.formMore.get('description').removeValidators(Validators.required);
          this.formMore.get('description').updateValueAndValidity();
        }
    })
      
    
    let jsonDec:Object ={
      entityName:"Mktpdiccol",
      condition:"idinstance = (select idinstance from Mktpdic where instancename = 'Mktpmeli')",
      
    };

    /// Multitable config ///

    
    this.dataMultiTableConfig=[]/* =[
      {
        columnName:'CODPROD',
        columnDesc: 'Cód. Produto',
        colspan:1,
        format:'INT'
      },
      {
        columnName:'VLRUNIT',
        columnDesc: 'Vlr.Unitário',
        colspan:1,
        format:'FLOAT'
      },
      {
        columnName:'VLRTOT',
        columnDesc: 'Vlr.Total',
        colspan:1,
        format:'TEXT'
      },
      {
        columnName:'DTALTER',
        columnDesc: 'Data de Alteração',
        colspan:1,
        format:'DATE',
        dateFromFormat: 'DDMMYYYY HH:mm:ss',
        dateFormat:'DD/MM/YYYY HH:mm:ss'
      }
    ];*/

    
    this.http.post(jsonDec,'JsonBrokerServices/find',false,true,true).subscribe(data=>{
          this.coldef = data['Mktpdiccol'];
        
          this.getOptions('porlocal');
          this.getOptions('tabpreco');
          this.getOptions('buying_mode');
          this.getOptions('currency_id');
          this.getOptions('item_condition');
          this.getOptions('listing_type_id');
          this.getOptions('shipping');
          this.getOptions('status');
          this.getOptions('envdescr');
          this.getOptions('envpicture');
          this.getOptions('envatrib');
          this.getOptions('envavar');
          this.getOptions('envfull');
          

          if ( this.data.evento!='inserindo'){
              let row = this.data['row'];
              
              this.formGroup.get('title').patchValue(row['TITLE']);
              this.formGroup.get('FAMILY_NAME').patchValue(row['FAMILY_NAME']);
              this.formGroup.get('USER_PRODUCT_ID').patchValue(row['USER_PRODUCT_ID']);
               
              this.formGroup.get('mlb_anuncio').patchValue(row['MLB_ANUNCIO']);
              this.formGroup.get('category_id').patchValue(row['CATEGORY_ID']);
              this.formGroup.get('warranty').patchValue(row['WARRANTY']);
              this.formGroup.get('currency_id').patchValue(row['CURRENCY_ID']);
              this.formGroup.get('listing_type_id').patchValue(row['LISTING_TYPE_ID']);
              this.formGroup.get('video_id').patchValue(row['VIDEO_ID']);
              this.formGroup.get('official_store_id').patchValue(row['OFFICIAL_STORE_ID']);
              this.formMore.get('description').patchValue(row["DESCRIPTION"]);
              this.formGroup.get('buying_mode').patchValue(row['BUYING_MODE']);
              this.formGroup.get('item_condition').patchValue(row['ITEM_CONDITION']);
              this.formGroup.get('shipping').patchValue(row['SHIPPING']);
              this.formGroup.get('permlink').patchValue(row['PERMLINK']);
              this.formGroup.get('envfull').patchValue(row['ENVFULL']);
              this.formGroup.get('catalog_product_id').patchValue(row['CATALOG_PRODUCT_ID']);
              
              if ( row['MLB_ANUNCIO'] != null && row['MLB_ANUNCIO'] != "0" ){
                this.formGroup.get('category_id').disable();
                this.formGroup.get('currency_id').disable();
                this.formGroup.get('official_store_id').disable();
                this.formGroup.get('listing_type_id').disable();
                this.formGroup.get('buying_mode').disable();
                this.formGroup.get('item_condition').disable();
                this.formGroup.get('shipping').disable();

                this.disablePredict = true;
              }

              this.formMid.get('price').patchValue(row['PRICE']);
              this.formMid.get('available_quantity').patchValue(row["AVAILABLE_QUANTITY"]);
              this.formMid.get('percentstk').patchValue(row["PERCENTSTK"]);
              this.formMid.get('multiplicador').patchValue(row["MULTIPLICADOR"]);
              this.formMid.get('percacres').patchValue(row["PERCACRES"]);
              this.formMid.get('percdesconto').patchValue(row["PERCDESCONTO"]);
              this.formMid.get('datavalpromo').patchValue(row["DATAVALPROMO"]);
              this.formMid.get('tabpreco').patchValue(row["TABPRECO"]);
              this.formMid.get('codtab').patchValue(row["CODTAB"]);
              this.formMid.get('codlocal').patchValue(row["CODLOCAL"]);
              this.formMid.get('porlocal').patchValue(row["PORLOCAL"]);
              //this.formMid.get('codecompany').patchValue({id:row["CODECOMPANY"],name:row["FK_MKTPMELI_MKTPCOMPANIES->NAME"]});
              
              
              this.formStatus.get("envpicture").patchValue(row['ENVPICTURE']);
              this.formStatus.get("envatrib").patchValue(row['ENVATRIB']);
              this.formStatus.get("envdescr").patchValue(row['ENVDESCR']);
              this.formStatus.get("envavar").patchValue(row['ENVAVAR']);
              this.formStatus.get("message").patchValue(row['MESSAGE']);
              this.formStatus.get("status").patchValue(row['STATUS']);

              let json = {
                  codecompany: row["CODECOMPANY"],
                  codeproduct: row["CODEPRODUCT"],
                  codecontract: row['CODECONTRACT'],
                  codemeli: row["CODEMELI"]
              }

              this.http.post(json,'MeliNotifications/getComplData',false,true,false).subscribe(data=>{

                  this.attribs = [];
                  this.garantias = [];
                  this.images = [];
                  this.varimage = [];
                  this.varAttribs = [];
                  this.variacoes = [];
                  this.oldAttribVar = [];
                  this.oldImageVar = [];
                  this.oldVariacoes = [];
                  this.oldGarantias = [];
                  this.oldAtrib = [];
                  this.oldImagens = [];
            
                  this.loadData(data);
                  this.cd.detectChanges();
                  this.spinner.hide("meliitemcontainer");

              },error=>{
                this.cd.detectChanges();
                this.spinner.hide("meliitemcontainer");
                throw error;
              });
        }else{
          if ( this.data.catalogProduct != null ){
            this.loadFromCatalogo(this.data.catalogProduct);
          }

          if ( this.data.row["CODECONTRACT"]!= null || (this.data.parentRow != null && this.data.parentRow.linha['CODECONTRACT'] != null)){
            let codecontract =  this.data.row["CODECONTRACT"] == null ? this.data.parentRow.linha['CODECONTRACT'] : this.data.row["CODECONTRACT"] ;
            let ob = {
              "entityName":"Mktpcontractpref",
              "sql":`SELECT  CONVERT(VARCHAR(100),B.CODECOMPANY)+' - ' +B.NAME COMPANY,A.CODECOMPANY,A.INTERNALID,A.NAME,A.TEXT, A.CODECONTRACT
                    FROM MKTPCONTRACTPREF A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
                    WHERE A.CODECONTRACT = ${codecontract}
                    AND A.NAME= 'mktp.meli.usa.multitable'
                    ORDER BY 1`
            }
            
            this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe({
              next:  (data)=>{
                  this.showMulti = false;
                  if ( data['SQL']){
                    if ( (data['SQL'] as Object[]).length > 0 ){
                      this.dataMultiTableConfig = JSON.parse(data['SQL'][0]['TEXT']);
                      this.showMulti = true;
                    }
                  }
                  this.cd.detectChanges();
                  this.spinner.hide("meliitemcontainer");
                },
              error: (error)=>{
                  this.spinner.hide("meliitemcontainer");
                  throw error; 
              }
               
            });
          }else{
            this.spinner.hide("meliitemcontainer");
          }
              
              
        }
    },error=>{
        this.spinner.hide("meliitemcontainer");
        throw error;
    });   
  }

  loadData(data){

      
      if ( ObjectUtil.isNotEmpty(data['imagem'])){
          let img:object[] = data['imagem'] as object[]; 

          img.forEach( imagem=> {
              this.images.push(imagem['text']);
              this.oldImagens.push(imagem['text']);
          });   
      }


      if ( ObjectUtil.isNotEmpty(data['atributo'])){
        let atributos:object[] = data['atributo'] as object[]; 

        atributos.forEach( atributo=> {
            this.rebuildjson(atributo);
            this.selectedAtrib.push(atributo);
            this.attribs.push(atributo);
            this.oldAtrib.push(atributo);
        });   
      } 

      
      if ( ObjectUtil.isNotEmpty(data['garantia'])){
        let garantias:object[] = data['garantia'] as object[]; 

        garantias.forEach( garantia=> {
            this.rebuildjson(garantia);
            this.selectedGarantia.push(garantia);
            this.garantias.push(garantia);
            this.oldGarantias.push(garantia);
        });   
       } 

      if ( ObjectUtil.isNotEmpty(data['variacoes'])){
        
        let v:object[] = data['variacoes'] as object[];
        
        v.forEach( variacao=>{
            
            if ( ObjectUtil.isNotEmpty(data['imageVar'])){
              let ivar:string[] = data['imageVar'] as string[];
              let images:string[] = [];
              ivar.forEach( imagem=>{
                  if ( imagem['codeproductvar'] == variacao['codeproductvar']){
                      images.push(imagem['text']);
                  } 
              });

              variacao['images'] = images;
            }else{
              variacao['images'] = [];
            }

            if ( ObjectUtil.isNotEmpty(data['attribVar'])){
              let v:object[] = data['attribVar'] as object[];
              let attribs:object[] = [];
              v.forEach( attrib=>{
                if ( attrib['codeproductvar'] == variacao['codeproductvar']){
                  this.rebuildjson(attrib);
                  attribs.push(attrib);
                }
              });
              variacao['attribs'] = attribs;
            }else{
              variacao['attribs']= [];
            }

            variacao['codeproductvar->NAME']=variacao['fk_mktpmeliskuvar_2_mktpproducts->name'];
            
            this.variacoes.push(variacao);
            this.oldVariacoes.push(variacao);
        });
      }

      
      
  
  }

  /**
   * Preenche o formulário com TODOS os dados disponíveis do produto
   * selecionado no catálogo do Mercado Livre (wizard de inserção).
   * Só sobrescreve o que existir no payload do catálogo.
   */
  loadFromCatalogo(prod: any){

      if ( prod == null ){
        return;
      }

      if ( ObjectUtil.isNotEmpty(prod['name']) ){
        this.formGroup.get('title').setValue(String(prod['name']).substring(0,60));
        this.formGroup.get('FAMILY_NAME').setValue(String(prod['family_name'] || prod['name']).substring(0,120));
      }

      if ( ObjectUtil.isNotEmpty(prod['id']) ){
        this.formGroup.get('catalog_product_id').setValue(prod['id']);
      }

      if ( ObjectUtil.isNotEmpty(prod['user_product_id']) ){
        this.formGroup.get('USER_PRODUCT_ID').setValue(prod['user_product_id']);
      }

      if ( ObjectUtil.isNotEmpty(prod['category_id']) ){
        this.formGroup.get('category_id').setValue(prod['category_id']);
      }

      if ( ObjectUtil.isNotEmpty(prod['buy_box_winner']) ){
        let winner = prod['buy_box_winner'];
        if ( ObjectUtil.isNotEmpty(winner['currency_id']) ){
          this.setIfOptionExists(this.formGroup, 'currency_id', winner['currency_id']);
        }
        if ( ObjectUtil.isNotEmpty(winner['listing_type_id']) ){
          this.setIfOptionExists(this.formGroup, 'listing_type_id', winner['listing_type_id']);
        }
        if ( ObjectUtil.isNotEmpty(winner['buying_mode']) ){
          this.setIfOptionExists(this.formGroup, 'buying_mode', winner['buying_mode']);
        }
        if ( ObjectUtil.isNotEmpty(winner['condition']) ){
          this.setIfOptionExists(this.formGroup, 'item_condition', winner['condition']);
        }
        if ( ObjectUtil.isNotEmpty(winner['warranty']) ){
          this.formGroup.get('warranty').setValue(winner['warranty']);
        }
      }

      // Imagens do catálogo
      if ( ObjectUtil.isNotEmpty(prod['pictures']) ){
        (prod['pictures'] as object[]).forEach(picture=>{
            let url = picture['url'] || picture['secure_url'];
            if ( url != null && this.images.indexOf(url) === -1 ){
              this.images.push(url);
            }
        });
      }

      // Atributos do catálogo (mesmo formato dos atributos da categoria)
      if ( ObjectUtil.isNotEmpty(prod['attributes']) ){
        (prod['attributes'] as object[]).forEach(attrib=>{

            // condição do item vem como atributo no catálogo
            if ( attrib['id'] == 'ITEM_CONDITION' ){
              this.setItemCondition(attrib);
            }

            attrib['id_atributo'] = attrib['id'];
            if ( this.attribs.findIndex(d=>d['id_atributo']==attrib['id_atributo']) === -1 ){
              this.attribs.push(attrib);
              this.selectedAtrib.push(attrib);
            }
        });
      }

      // Descrição curta do catálogo
      if ( ObjectUtil.isNotEmpty(prod['short_description']) && ObjectUtil.isNotEmpty(prod['short_description']['content']) ){
        this.formMore.get('description').setValue(prod['short_description']['content']);
      }

      this.cd.markForCheck();
  }

  /** Converte o atributo ITEM_CONDITION do catálogo para o valor do select do formulário. */
  private setItemCondition(attrib: object){
      let raw = String(attrib['value_id'] || attrib['value_name'] || '').toLowerCase();
      let valueName = String(attrib['value_name'] || '').toLowerCase();

      let condition: string = null;
      if ( raw == '2230284' || valueName.indexOf('novo') > -1 || valueName == 'new' ){
        condition = 'new';
      }else if ( raw == '2230581' || valueName.indexOf('usado') > -1 || valueName == 'used' ){
        condition = 'used';
      }else if ( valueName.indexOf('recondicionado') > -1 || valueName.indexOf('refurbished') > -1 ){
        condition = 'refurbished';
      }

      if ( condition != null ){
        this.setIfOptionExists(this.formGroup, 'item_condition', condition);
      }
  }

  /** Só aplica o valor se ele existir nas opções do dicionário (ou se o dicionário não tiver opções). */
  private setIfOptionExists(form:UntypedFormGroup, controlName:string, value:any){
      let options = this.dataValue.get(controlName) as object[];
      if ( options == null || options.length === 0 || options.findIndex(o=>o['value']==value) > -1 ){
        form.get(controlName).setValue(value);
      }
  }

  rebuildjson(value){

    if ( ObjectUtil.isNotEmpty(value['allowed_units'])){
      value['allowed_units'] = JSON.parse(value['allowed_units']);
    }

    
    if ( ObjectUtil.isNotEmpty(value['options'])){
      value['values'] = JSON.parse(value['options']);
    }

    if ( ObjectUtil.isNotEmpty(value['tags'])){
      value['tags'] = JSON.parse(value['tags']);
    }
  }

  addImage(): void {
    const value = (this.imageCtrl.value || '').trim();

    if (value && this.images.indexOf(value) === -1) {
      this.images.push(value);
    }

    this.imageCtrl.setValue(null);
  }

  removeImage(image: string): void {
    const index = this.images.indexOf(image);

    if (index >= 0) {
      this.images.splice(index, 1);
    }
  }



  getFrom(from:string,to:string, form:UntypedFormGroup ,event:Event){

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (ObjectUtil.isNotEmpty(this.data.parentRow.linha)){
          form.get(to).setValue(this.data.parentRow.linha[from]);
      }
      
  }

  formSubmitted(evento){
    if ( evento.id == null ){
      this.formGroup.get('category_id').setValue(evento);
    }else{
      this.formGroup.get('category_id').setValue(evento.id);
    }
    
  }

  buscarAtributos(){

    
    if ( !ObjectUtil.isNotEmpty(this.formGroup.get("category_id").value) ){
        this.snackBar.showError("Não informado o código de categoria.");
        this.spinner.show("meliitemcontainerattrib");
        return;
    }

    
    let ob = {
      codeCompany : this.data.row["CODECOMPANY"] == null ? this.formGroup.get("CODECOMPANY").value: this.data.row["CODECOMPANY"],//this.uid.user.codecompany,
      method: "GET",
      serviceName: "FindAttribByCat",
    }

    ob['params']=[{
        key:"@CATEGORYID",
        value:this.formGroup.get("category_id").value
    }];

    
    this.spinner.show("meliitemcontainerattrib");
    
    this.selectedAtrib = [];

    this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(data=>{
        this.attribValidator = [];    
        let tempAttrib:Object[] = data['resultado'];
        //console.log(data);
        tempAttrib.forEach(a=>{
          a['id_atributo'] = a['id'];
        })

        if ( this.attribs.length > 0 ){
          this.dialogService.openNewDialog("Já existem atributos carregados. Deseja limpar e carregar novamente?",(data)=>{
              if ( data ){
                  this.attribs = [];
                  this.selectedAtrib = [];
              }  
              this.loadAtributos(tempAttrib);
          },()=>{
              this.loadAtributos(tempAttrib);
          });
        }else{
            this.loadAtributos(tempAttrib);
        }

        
      },error=>{
        this.spinner.hide("meliitemcontainerattrib");
        throw error;
      });

  }

  loadAtributos(tempAttrib){

        tempAttrib.forEach(data=>{
          if ( this.attribs.findIndex(d=>d['id_atributo']==data['id_atributo']) == -1){
                this.attribs.push(data)
                this.selectedAtrib.push(data);
            }
        })
        
        this.loadPrediction();
        this.cd.markForCheck();

        this.spinner.hide("meliitemcontainerattrib");

  }

  deleteItem(ob:object, type:string){
      return;
      /*if ( type  == 'G'){
        var index = this.garantias.findIndex(x=>x['id_atributo']==ob['id_atributo']);
        this.garantias.splice(index,1);       
        var index2 = this.selectedGarantia.findIndex(x=>x['id_atributo']==ob['id_atributo']);
        this.selectedGarantia.splice(index2,1);       
        
      }else{
        var index = this.attribs.findIndex(x=>x['id_atributo']==ob['id_atributo']);
        this.attribs.splice(index,1);        
        var index2 = this.selectedAtrib.findIndex(x=>x['id_atributo']==ob['id_atributo']);
        this.selectedAtrib.splice(index2,1);      
      }*/

  }

  afterLoad(event, nomeControle){
      
    let row = this.data['row'];
    if ( event ){
      if ( nomeControle == 'codecompany'){
        this.formMid.get(nomeControle).patchValue({id:row['CODECOMPANY'],name:row['FK_MKTPMELI_MKTPCOMPANIES->NAME']});
      }
    }
  }

  canAddVariation(){

    let retorno = false;
    if ( ObjectUtil.isNotEmpty(this.selectedAtrib)){
      this.selectedAtrib.forEach(data=>{
        if ( ObjectUtil.isNotEmpty(data['tags']) ){
          if ( ObjectUtil.isNotEmpty(data['tags']['allow_variations'])){
            let allow_variations  = data['tags']['allow_variations'];
              if( allow_variations){
                if (  ObjectUtil.isNotEmpty(data["value_id"])  ){
                  retorno = true;
                  return retorno;
                }
              }
            }
          }
      });
    }

    return retorno;

  }


  checkAtribVar(item){
    
    if ( ObjectUtil.isNotEmpty(item['tags']) ){
      if ( ObjectUtil.isNotEmpty(item['tags']['allow_variations'])){
        let allow_variations  = item['tags']['allow_variations'];
          if( allow_variations){
            return true;
          }else{
            return false;
          }
      }else{
        return false;
      }
    }else{
      return false;
    }
  }

/*  itemSelect(event){
    let row = this.data['row'];
    row['CODECOMPANY'] = event.id; 
    row['FK_MKTPMELI_MKTPCOMPANIES->NAME'] = event.name;
    this.formMid.get("codecompany").patchValue({id:row['CODECOMPANY'],name:row['FK_MKTPMELI_MKTPCOMPANIES->NAME']});

  }*/

  loadPrediction(){

      if ( this.selectedPrediction !=null ){
        if ( this.attribs != null  && ObjectUtil.isNotEmpty( this.selectedPrediction.attributes)){
          this.attribs.forEach(atrib=>{
            let pa:Object  = (this.selectedPrediction.attributes as Object[]).find(x=>x['id']==atrib['id'])
            if ( pa != null ){
              atrib['value_name'] = pa['value_name'];
              atrib['value_id'] = pa['value_id'];
            }
          });
        }
      }

  }

  clear(formcontrolName:string, formControl:UntypedFormGroup , event:Event){
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();

      formControl.get(formcontrolName).setValue(null);

  }



  buscarGarantia(){

    if ( !ObjectUtil.isNotEmpty(this.formGroup.get("category_id").value) ){
        this.snackBar.showError("Não informado o código de categoria.");
        return;
    }

    let ob = {
      codeCompany : this.data.row["CODECOMPANY"] == null ? this.formGroup.get("CODECOMPANY").value: this.data.row["CODECOMPANY"],//this.uid.user.codecompany,
      method: "GET",
      serviceName: "FindTermsByCat",
    }

    ob['params']=[{
        key:"@CATEGORYID",
        value:this.formGroup.get("category_id").value
    }];

    this.spinner.show("meliitemcontainerattrib");
    
      this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(data=>{
       
        let tempGarantias = data['resultado'];
        tempGarantias.forEach(a=>{
          a['id_garantia'] = a['id'];
        })

        if ( this.garantias.length > 0 ){
          this.dialogService.openNewDialog("Já existem garantias carregadas. Deseja limpar e carregar novamente?",(data)=>{
              if ( data ){
                  this.garantias = [];
                  this.selectedGarantia = [];
              }  
              this.loadGarantias(tempGarantias);
          },()=>{
              this.loadGarantias(tempGarantias);
          });
        }else{
            this.loadGarantias(tempGarantias);
        }

      },error=>{
        this.spinner.hide("meliitemcontainerattrib");
        throw error;
      });

  }

  loadGarantias(tempGarantias){
    
    tempGarantias.forEach(data=>{
      if ( this.garantias.findIndex(d=>d['id_garantia']==data['id_garantia']) == -1){
        
        if ( this.canAddGarantias (data)){
          this.garantias.push(data)
          this.selectedGarantia.push(data);
        }
      }
    })

    this.cd.markForCheck();
    this.spinner.hide("meliitemcontainerattrib");

  }

  slideChange(checked:boolean, type:string){

      if (type =="G"){
          this.showHiddenGarantia = checked;
      }

      if (type =="A"){
        this.showHiddenAtributo = checked;
    }
  }

  canAddGarantias(data){
    
    let retorno = true;
    if ( ObjectUtil.isNotEmpty(data['tags']) ){
      if ( ObjectUtil.isNotEmpty(data['tags']['read_only'])){
        let allow_variations  = data['tags']['read_only'];
          if( allow_variations){
            return false;
          }
        }
      }
    
      return retorno;
  }

  predicaoCategoria(event:Event){

    if ( !ObjectUtil.isNotEmpty(this.formGroup.get("title").value) ){
      this.snackBar.showError("Para predição de categoria é necessário preencher o título.");
      return;
    }

    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();

    let ob = {
      codeCompany : this.data.row["CODECOMPANY"] == null ? this.formGroup.get("CODECOMPANY").value: this.data.row["CODECOMPANY"],//this.uid.user.codecompany,
      method: "GET",
      serviceName: "CatPrediction",
    }

    ob['params']=[{
        key:"?q",
        value:`encodeString(${this.formGroup.get("title").value})`
    }];

    
    this.spinner.show("meliitemcontainer");
    
    this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(data=>{
      
      this.prediction = data['resultado'];
      
      this.spinner.hide("meliitemcontainer");

      this.dialogService.openGenericDialog(MeliCategoryPredictorComponent,this.prediction,(value)=>{
          this.selectedPrediction = value;
          if ( this.selectedPrediction != null ){
            this.formGroup.get('category_id').setValue(this.selectedPrediction['category_id']);
          }
      })
    },error=>{
      this.spinner.hide("meliitemcontainer");
      throw error;
    });


  }

  onBlur(item,type){
      
      if( type == "A"){
          let index = this.selectedAtrib.findIndex(x=> x['id_atributo']==item['id_atributo'] );
          
          if ( index > -1 ){
            this.selectedAtrib[index] = item;
          }else{
            this.selectedAtrib.push(item);
          }

          // if ( index > -1 ){
          //     this.selectedAtrib.splice(index,1);
          // }
          

          // if ( item.value_id != null ){
          //   this.selectedAtrib.push(item);
          // }else{
          //   if ( index > -1 ){
          //     this.selectedAtrib.splice(index,1);
          //   }
          // }
          
      }else{
          let index = this.selectedGarantia.findIndex(x=> x['id_garantia']==item['id_garantia'] )

          if ( index > -1 ){
            this.selectedGarantia[index] = item;
          }else{
            this.selectedGarantia.push(item);
          }


          // if ( index > -1 ){
          //     this.selectedGarantia.splice(index,1);
          // }
          // if ( item.value_id != null ){
          //   this.selectedGarantia.push(item);
          // }else{
          //   if ( index > -1 ){
          //     this.selectedGarantia.splice(index,1);
          //   }
          // }
      }

  }


  generateTagString(tags:Object){
    let value = '';
    if ( tags != null){
      Object.keys(tags).forEach(tag=>{
          value =  value + tag + ': ' + tags[tag]+ '\n';
      })
    }
    return value;
  }

  isRequired(item:object, type:string){

    if ( type == "A"){
      if ( item['hierarchy']=='PARENT_PK'){
        return true;
      }
    }

    return false;

  }

  setControle(controle:string[]){

      if ( !this.formGroup.pristine || !this.formMore.pristine || !this.formMid.pristine){
        controle.push('Mktpmeli');
      }

      if ( this.hasChanged(this.oldImagens, this.images) ){
          controle.push('Mktpmeliimage');
      }

      if ( this.hasChanged(this.oldAtrib, this.selectedAtrib) ){
        controle.push('Mktpmeliatrib');
      }

      if ( this.hasChanged(this.oldGarantias, this.selectedGarantia) ){
        controle.push('Mktpmeligarantia');
      }

      if ( this.hasChanged(this.oldVariacoes, this.variacoes) ){
        controle.push('Mktpmeliskuvar');
      }

      if ( this.hasChanged(this.oldImageVar, this.varimage) ){
        controle.push('Mktpmeliskuvarimage');
      }

      if ( this.hasChanged(this.oldAttribVar, this.varAttribs) ){
        controle.push('Mktpmeliatribvar');
      }

  }

  // comparação por conteúdo: comparação por referência marcava tudo como alterado sempre
  private hasChanged(oldValue:any[], newValue:any[]): boolean {
      try{
        return JSON.stringify(oldValue||[]) !== JSON.stringify(newValue||[]);
      }catch(e){
        return true;
      }
  }

  salvar(){
    
      if ( this.attribValidator.length > 0 && !this.byCatalogo){
        this.snackBar.showError("Existem atributos obrigatórios não preechidos.");
        return;
      }

      if ( this.images.length == 0  && !this.byCatalogo){
        this.snackBar.showError("Preenchimento da imagem é obrigatório.");
        return;
      }

      if ( this.formGroup.get("CODECOMPANY").value != null){

        let ob  = this.formGroup.get("CODECOMPANY").value;
        if ( !ObjectUtil.isNotEmpty(ob)){
          this.snackBar.showError("Preenchimento da Empresa é obrigatória.");
          return;
        }

      }


      if ( this.dataMultiTable.length == 0 || this.dataMultiTable ==null ){
        this.dataMultiTable.push({})
      }

      if ( this.dataMultiTable.length > 1 ){
        this.dialogService.errorDialoag = false;
        this.dialogService.openNewDialog(
          `Serão criados ${this.dataMultiTable.length} anúncios. Deseja continuar?`,
          async () => {
              await this.savingDataMeli();
              this.saving.emit({changing:true,keepOpen:false});
              this.spinner.hide("meliitemcontainer"); 
          });
        
      }else{
        this.savingDataMeli();
      }
  }


  async savingDataMeli(){

      if ( this.formGroup.valid && this.formMore.valid  && this.formMid.valid){

        for ( const multiData of this.dataMultiTable ){
          let controle:string[] = [];
        
          if ( this.evento != 'inserindo'){
              this.setControle(controle);          
          }
          
          this.sanitizeDataBeforeSendToServer(this.formGroup);
          this.sanitizeDataBeforeSendToServer(this.formMore);
          this.sanitizeDataBeforeSendToServer(this.formMid);

          let ob = {
              type: this.evento, 
              produto: this.evento =="inserindo" ? this.data.parentRow.linha : this.data.row,
              formGroup: this.applyMultiTableData(multiData,this.formGroup.getRawValue()),
              formMore: this.applyMultiTableData(multiData,this.formMore.getRawValue()),
              formMid: this.applyMultiTableData(multiData,this.formMid.getRawValue()),
              imagens: this.applyMultiTableData(multiData,this.images),
              atributos: this.applyMultiTableData(multiData,this.selectedAtrib),
              garantias: this.applyMultiTableData(multiData,this.selectedGarantia),
              variacoes: this.applyMultiTableData(multiData,this.variacoes),
              //imageVar: this.varimage,
              //attribVar: this.varAttribs,
              control: controle
              
          }

          await new Promise((resolve, reject) => {
            this.spinner.show("meliitemcontainer");
            this.http.post(ob,'MeliNotifications/createProduct',false,true,false).subscribe(data=>{  
            
              if ( this.data.evento =='inserindo'){
                this.snackBar.showSuccess("Registro incluído com sucesso.");
                if ( this.dataMultiTable.length > 1){
                  
                }else{
                  this.formGroup.get("CODEMELI").patchValue(data["CODEMELI"]);
                  this.data.row['CODECONTRACT'] = this.data.row["CODECONTRACT"];//this.data.parentRow.linha['CODECONTRACT'];
                  this.data.row['CODEMELI'] = data["CODEMELI"];
                  this.data.row['CODEPRODUCT'] = this.data.row["CODEPRODUCT"]; //this.data.parentRow.linha['CODEPRODUCT']; 
                  this.data.evento ="editando";
                  this.evento ="editando";
                  this.saving.emit({changing:true,keepOpen:true});
                  this.spinner.hide("meliitemcontainer"); 
                }
              }else{
                this.formGroup.get("CODEMELI").patchValue(data["CODEMELI"]);
                this.snackBar.showSuccess("Registro alterado com sucesso.");
                this.saving.emit({changing:true,keepOpen:true});
                this.spinner.hide("meliitemcontainer"); 
              }
            
            
              resolve(true);  
            },error=>{
              this.spinner.hide("meliitemcontainer");
              this.saving.emit({changing:false,keepOpen:false});
              resolve(false);
              throw error;
          });
          
        });
      }

        

      }else{
          this.formGroup.markAllAsTouched();
          this.formMid.markAllAsTouched();
          this.formMore.markAllAsTouched();
          if ( !this.formGroup.valid){
            let errors = this.formServices.getFormErrors(this.formGroup,[],"<br/>", 'MKTPMELI');
            this.message.error(errors);
          }

          if ( !this.formMid.valid){
            let errors = this.formServices.getFormErrors(this.formMid,[],"<br/>", 'MKTPMELI');
            this.message.error(errors);
          }
          
          if ( !this.formMore.valid){
            let errors = this.formServices.getFormErrors(this.formMore,[],"<br/>", 'MKTPMELI');
            this.message.error(errors);
          }

          return;
          //this.snackBar.showError("Não foi possível salvar. Verificar cadastro.");
      }


  }


  applyMultiTableData(multiData: Object, data:Object|Object[]) {

    if ( data instanceof Array){
      let newData = JSON.parse(JSON.stringify(data));
      newData.forEach(linha=>{
        Object.keys(linha).forEach(field=>{
          let value = linha[field];
          if ( value!= null && typeof(value)=='string' ){
            let reg: RegExpMatchArray = value.match(/{@MULTI_(.*?)}/g);
            
            if (reg != null) {

                reg.forEach(d=>{
                  let fieldName = d.replace("{@MULTI_", "").replace("}", "");
                  let newValue = multiData[fieldName];
                  linha[field] = linha[field].replace(d,newValue)
                })
                  // let fieldName = value.replace("{@MULTI_", "").replace("}", "");
                  
                  // let newValue = multiData[fieldName];
                  // linha[field]=newValue;
            }
          }
        })
      })
      return newData;
    }else{
      
      Object.keys(data).forEach(field=>{
          let value = data[field];
          
          if ( value!= null && typeof(value)=='string' ){
            
            let reg: RegExpMatchArray = value.match(/{@MULTI_(.*?)}/g);
            if (reg != null) {
              reg.forEach(d=>{
                let fieldName = d.replace("{@MULTI_", "").replace("}", "");
                let newValue = multiData[fieldName];
                data[field] = data[field].replace(d,newValue)
              })
                
            }
          }
      })
      return data;
    }
    
    
  }

  getDataFromTable(fromControl:any, fieldName: string, event, externalExpression:string, ehArray:boolean = false, pkCheck?:string, externalParam?:Object[]){

    
    if ( externalExpression != null ){
  
      this.spinner.show('meliitemcontainer');
      let arrayData:Object[] = [];

      if ( externalParam != null ){
        if ( externalParam.length > 0 ){
          externalParam.forEach(data=>{
            arrayData.push(data);
          })
        }
      }
      
      arrayData.push({
          'key':'@CODPROD',
          'value':this.data.parentRow ==null? this.formGroup.get("CODEPRODUCT").value : this.data.parentRow.linha["CODEPRODUCT"]
      });


      arrayData.push({
        'key':'@CODLOCAL',
        'value': this.formMid.get('codlocal').value
      });

      arrayData.push({
        'key':'@CODTAB',
        'value': this.formMid.get('codtab').value
      })

      Object.keys(this.formGroup.controls).forEach(control=>{
        const abstractControl = this.formGroup.controls[control];
        
        if ( abstractControl.value != null){
          arrayData.push({
            'key':'@'+control.toUpperCase(),
            'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
          })
        }
      })

      Object.keys(this.formMid.controls).forEach(control=>{
        const abstractControl = this.formMid.controls[control];
        
        if ( abstractControl.value != null){
          arrayData.push({
            'key':'@'+control.toUpperCase(),
            'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
          })
        }
      })

      Object.keys(this.formCompl.controls).forEach(control=>{
        const abstractControl = this.formCompl.controls[control];
        
        if ( abstractControl.value != null){
          arrayData.push({
            'key':'@'+control.toUpperCase(),
            'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
          })
        }
      })


      Object.keys(this.formMore.controls).forEach(control=>{
        const abstractControl = this.formMore.controls[control];
        
        if ( abstractControl.value != null){
          arrayData.push({
            'key':'@'+control.toUpperCase(),
            'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
          })
        }
      })


      Object.keys(this.formStatus.controls).forEach(control=>{
        const abstractControl = this.formStatus.controls[control];
        
        if ( abstractControl.value != null){
          arrayData.push({
            'key':'@'+control.toUpperCase(),
            'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
          })
        }
      })

      let ob = {
        'expressao': externalExpression,
        'novo':true,
        'codecontract': this.data.row["CODECONTRACT"]== null ? this.formGroup.get("CODECONTRACT").value: this.data.row["CODECONTRACT"],//this.uid.user.codecompany,
        'codecompany': this.data.row["CODECOMPANY"] == null ? this.formGroup.get("CODECOMPANY").value: this.data.row["CODECOMPANY"],//this.uid.user.codecompany,
        'codemktp':3,
        'values':arrayData
      } 

      this.http.post(ob, 'FormulaServices/test',false,true,true).subscribe(data=>{
        let resultado = data['resultado'];
        let objeto  = JSON.parse(resultado);
        let SQL:Object[] = objeto['SQL'];
        let value:string | string[] | Object[] = null;
        
        

        if ( SQL != null && SQL.length > 0 ){
          if ( !ehArray){
            value = SQL[0]['VALOR'];
          }else{
            
            if ( event =="complex"){
              (value as Object[]) = [];  
            }else{
              (value as string[]) = [];
            }
            
            SQL.forEach(data=>{
              if ( event =="complex"){
                  (value as Object[]).push(data); 
              }else{
                (value as string[]).push(data['VALOR']);
              }
              
            })
          }
           
        }
        
        if ( value != null ){
            if ( !ehArray){
              if ( fromControl instanceof UntypedFormGroup){
                (fromControl as UntypedFormGroup).get(fieldName).setValue(value);
              }else{
                if ( fromControl instanceof Object){
                  fromControl[fieldName] = value;
                }
              }
              
            }else{
              
              if ( event == "complex"){
                
                (value as object[]).forEach(data=>{
                  if ( pkCheck !=null ){
                    if ( this[fromControl as string].length > 0 ){
                      if (this[fromControl as string].findIndex(x=> x[pkCheck] == data[pkCheck])== -1 ){
                        this[fromControl as string].push(data);
                      }
                    }else{
                      this[fromControl as string].push(data);
                    }
                  }else{
                      this[fromControl as string].push(data);
                  }
                });
              }else{
                this[fromControl as string]  = [];
                (value as string[]).forEach(data=>{
                  this[fromControl as string].push(data);
                });
              }
              

            }
        }
        

        this.spinner.hide('meliitemcontainer');
        this.cd.markForCheck();
      },error=>{
        this.spinner.hide('meliitemcontainer');
        throw error;
      },()=>{
        this.spinner.hide('meliitemcontainer');
      });

    }
  }

  openDataOption(item){
      
     let array =  [{
        "key":"@IDATRIBUTO",
        "value":item["id_atributo"]
      }]
      
      this.getDataFromTable(item,'value_id',"complex","{@getAttibValueErp}",false,null,array);
  }

  removeVariacao(){

  }

  addVariacao(){
      
      setTimeout(()=>{
        this.varServices.changeFace('insertFace'); 
        this.cd.markForCheck();
      },100)
      this.disableAddVar = true;
  }

  
  cancelarVariacao(){
      
      setTimeout(()=>{
        this.varServices.changeFace('cancel'); 
        this.cd.markForCheck();
      },100);
      
      this.selectedDataVar = {};
      this.disableAddVar = false;
      
  }

  salvandoVariacao(salvando){

    if ( salvando ){
      setTimeout(()=>{
        this.varServices.changeFace('gridFace'); 
        this.cd.markForCheck();
      },100);
      this.selectedDataVar = {};
      this.disableAddVar = false;
    }else{
      this.disableAddVar = true;
    }
    
  }

  getArray(item){
      if ( item instanceof Array){
        this.dataObserve =  item
      }else{
        this.dataObserve =  JSON.parse(item)
      }
  }

  buscarVariacao(){
    this.getDataFromTable('variacoes',null,"complex","{@getVariacaoErp}",true,"codeproductvar");    
  }

  checkHidden(item,type){
      
      let isHidden = false;
      if ( item!= null ){
        if ( ObjectUtil.isNotEmpty(item['tags']) ){
          if ( ObjectUtil.isNotEmpty(item['tags']['hidden'])){
            isHidden = item['tags']['hidden'];
          }
        }
        
        if ( type=="G"){
          if ( item['id'] !='WARRANTY_TIME' &&  item['id'] !='WARRANTY_TYPE'){
            isHidden = true;
          }
        }
      
        if ( type=="G"){
            if ( isHidden ){
              if ( this.showHiddenGarantia ){
                return false;
              }else{
                return true;
              }
            }else{
              return false;
            }
        }
  
        if ( type =="A"){
          if ( isHidden ){
            if ( this.showHiddenAtributo ){
              return false;
            }else{
              return true;
            }
          }else{
            return false;
          }
        }
        
      }
      return isHidden;
      
  }

  
  sanitizeDataBeforeSendToServer(form:UntypedFormGroup): void {
    
    Object.keys(form.controls).forEach(control=>{
      const abstractControl = form.controls[control];
      
      if ( abstractControl.value != null){
        if ( abstractControl.value instanceof String ){
          if ((abstractControl.value as string)?.trim() === '') {
            abstractControl.setValue(null);
          }
        }else{
          if (abstractControl.value=== '') {
            abstractControl.setValue(null);
          }
        }
      }
    })
  }

  buscarDadosMultiTable(){

    if ( this.formGroup.get("CODECOMPANY").value == null){
      throw Error('Não informado a empresa para pesquisa.');
    }
    
    let arrayData:Object[] = [];
    this.spinner.show('melimultitable');
    arrayData.push({
      'key':'@CODPROD',
      'value': this.data.parentRow.linha["CODEPRODUCT"]
    });


    arrayData.push({
      'key':'@CODLOCAL',
      'value': this.formMid.get('codlocal').value
    });

    arrayData.push({
      'key':'@CODTAB',
      'value': this.formMid.get('codtab').value
    })

    Object.keys(this.formGroup.controls).forEach(control=>{
      const abstractControl = this.formGroup.controls[control];
      
      if ( abstractControl.value != null){
        arrayData.push({
          'key':'@'+control.toUpperCase(),
          'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
        })
      }
    })

    Object.keys(this.formMid.controls).forEach(control=>{
      const abstractControl = this.formMid.controls[control];
      
      if ( abstractControl.value != null){
        arrayData.push({
          'key':'@'+control.toUpperCase(),
          'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
        })
      }
    })

    Object.keys(this.formCompl.controls).forEach(control=>{
      const abstractControl = this.formCompl.controls[control];
      
      if ( abstractControl.value != null){
        arrayData.push({
          'key':'@'+control.toUpperCase(),
          'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
        })
      }
    })


    Object.keys(this.formMore.controls).forEach(control=>{
      const abstractControl = this.formMore.controls[control];
      
      if ( abstractControl.value != null){
        arrayData.push({
          'key':'@'+control.toUpperCase(),
          'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
        })
      }
    })


    Object.keys(this.formStatus.controls).forEach(control=>{
      const abstractControl = this.formStatus.controls[control];
      
      if ( abstractControl.value != null){
        arrayData.push({
          'key':'@'+control.toUpperCase(),
          'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
        })
      }
    })

    
      let ob = {
        'expressao': '{@getMultiTable}',
        'novo':true,
        'codecontract':this.data.row["CODECONTRACT"] == null ? Number(this.formGroup.get("CODECONTRACT").value): this.data.row["CODECONTRACT"],//this.uid.user.codecompany,
        'codecompany': this.data.row["CODECOMPANY"] == null ? Number(this.formGroup.get("CODECOMPANY").value): this.data.row["CODECOMPANY"],//this.uid.user.codecompany,
        'codemktp':3,
        'values':arrayData
      } 

      this.http.post(ob, 'FormulaServices/test',false,true,true).subscribe(data=>{
        let resultado = data['resultado'];
        let objeto  = JSON.parse(resultado);
        let SQL:Object[] = objeto['SQL'];
        
        if ( SQL ){
            this.dataMultiTable = SQL;
        }else{
          this.dataMultiTable =[];//;objeto;
        } 
        

        this.spinner.hide('melimultitable');
        this.cd.markForCheck();
      },error=>{
        this.spinner.hide('melimultitable');
        throw error;
      },()=>{
        this.spinner.hide('melimultitable');
      });

  }

  drag(event: any) {
    
    const value = event.target.dataset.value;
    

    let item = event.target.dataset.dragData;

    event.dataTransfer.setData('text/plain', item);
  }


  sair(){
      this.saving.emit({changing:false,keepOpen:false});
  }
  
}

